import React, { memo } from "react";
import "./PollutionAmountBadge.css";

interface PollutionAmountBadgeProps {
  amount: number;
}

const PollutionAmountBadge: React.FC<PollutionAmountBadgeProps> = memo(
  ({ amount }) => {
    const getTrashIcon = (value: number): string => {
      if (value < 10) return `${process.env.PUBLIC_URL}/images/trash0.png`;
      if (value < 20) return `${process.env.PUBLIC_URL}/images/trash1.png`;
      return `${process.env.PUBLIC_URL}/images/trash2.png`;
    };

    const getIntensityLabel = (value: number): string => {
      if (value < 10) return "Low";
      if (value < 20) return "Medium";
      return "High";
    };

    const icon = getTrashIcon(amount);
    const label = getIntensityLabel(amount);

    return (
      <div className="pollution-amount-badge">
        <span className="badge-amount">{amount}</span>
        <img src={icon} alt={label} className="badge-icon" />
      </div>
    );
  }
);

PollutionAmountBadge.displayName = "PollutionAmountBadge";

export default PollutionAmountBadge;
